import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import NotFound from 'srcReact/components/common2/NotFound'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import NewFeed from 'srcReact/components/common2/NewFeed'
import styles from './styles.module.scss'
import FeedsTabContent from 'srcReact/components/common2/FeedsTabContent'
import FileNavigationPopup from 'srcReact/components/common2/FileNavigationPopup'
import Spinner from 'srcReact/components/common2/Spinner'
import { commonActions } from 'srcReact/components'
import { generalFeedActions } from 'srcReact/FeedPage'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { checkNested } from 'srcReact/helpers/validator'
import { urlSearchParams } from 'srcReact/helpers/utils'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { commonFeedActions } from 'srcReact/components/common2/FeedsTabContent/actions'
import PendingMessageCount from 'srcReact/components/common2/FeedsTabContent/components/PendingMessageCount'

export default function Feeds({ isGroupOrganizer, feedIdToScroll, setFeedIdToScroll }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const [organizationId, setOrganizationId] = useState(null)
  const [workplaceIds, setWorkplaceIds] = useState([])
  // const [apiTriggered, setApiTriggered] = useState(false)
  const [availableCTAs, setAvailableCTAs] = useState([])
  const [pendingMessgeCount, setPendingMessgeCount] = useState(0)
  const [apiTriggeredForNewContent, setApiTriggeredForNewContent] = useState(false)

  const [files, setFiles] = useState([])
  const {
    login: { user: loggedInUser },
    common: { isNative, tagUsersList },
    commonNewsfeed: {
      feeds: { list, stats, loading: loadingFeeds, success: loadedFeeds },
      newsFeedList: { selected: selectedNewsFeed, groups, mixrs }
    },
    feedHome: { group, loadingSendMessage, isMessagePosted, message_draft, serverErrors, ctas },
    organization: {
      current_organization,
      header: { newsfeed }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    // if (!apiTriggered) {
    // nativeapp
    if (isNative) {
      setOrganizationId(urlSearchParams('organization_id'))
      setWorkplaceIds(urlSearchParams('id_workplace').toString())
      dispatch(commonActions.getTagUsers('workplace', urlSearchParams('id_workplace').toString()))
      dispatch(
        commonFeedActions.getFeeds(
          'organization',
          urlSearchParams('organization_id'),
          pagination,
          false, //is new content
          urlSearchParams('id_workplace').toString(),
          'members'
        )
      )
      // setApiTriggered(true)
      return
    }

    if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
      const workplaceIds = current_organization.info.my_access.role_as_workplace_member.workplace_list
      if (workplaceIds && workplaceIds.length >= 1) {
        setOrganizationId(current_organization.info.id)
        setWorkplaceIds(workplaceIds.toString())
        dispatch(commonActions.getTagUsers('workplace', workplaceIds.toString()))
        dispatch(
          commonFeedActions.getFeeds(
            'organization',
            current_organization.info.id,
            pagination,
            false, //is new content
            workplaceIds.toString(),
            'members'
          )
        )
        // setApiTriggered(true)
      }
    }
    // }
  }, [current_organization && current_organization.info && current_organization.info.id])

  const getCurrentQuantity = () => {
    return stats.nextOffset < appConstantSettings.PAGINATION_QUANTITY
      ? appConstantSettings.PAGINATION_QUANTITY
      : stats.nextOffset
  }

  const lastFeedRef = useInfinitScroll(
    loadingFeeds,
    stats && stats.remaining,
    stats && stats.nextOffset,
    setPagination,
    [loadingFeeds, stats]
  )

  useEffect(() => {
    let arr = []
    if (ctas.new_members?.total_new_member_count > 0) {
      arr.push('new_members')
    }
    if (ctas.interest_suggestions?.length > 0) {
      arr.push('interest_suggestions')
    }
    if (ctas.a_new_group?.length > 0) {
      arr.push('a_new_group')
    }
    setAvailableCTAs(arr)
  }, [ctas.new_members])

  useEffect(() => {
    if (!selectedNewsFeed?.id && newsfeed?.new_content === 1) {
      dispatch(
        commonFeedActions.getFeeds(
          'organization',
          current_organization.info.id,
          pagination,
          true, //is new content
          workplaceIds.toString(),
          'members'
        )
      )
      setApiTriggeredForNewContent(true)
    } else if (newsfeed?.background_message_posting_count > 0) {
      //this reducer data (newsfeedid and count) will be used file modal if open
      dispatch(commonFeedActions.setPendingMessageCount(0, newsfeed.background_message_posting_count))
      setPendingMessgeCount(newsfeed.background_message_posting_count)
    } else {
      dispatch(commonFeedActions.setPendingMessageCount(-1, 0))
      setPendingMessgeCount(0)
    }
  }, [selectedNewsFeed, newsfeed?.new_content, newsfeed?.background_message_posting_count])

  useEffect(() => {
    // once newsfeed list is loaded(after called on organization.header.newsfeed.new_content becoming 1),
    // set pending message count to background_message_posting_count
    if (loadedFeeds && apiTriggeredForNewContent) {
      setApiTriggeredForNewContent(false)
      dispatch(
        commonFeedActions.setPendingMessageCount(
          newsfeed?.background_message_posting_count === 0 ? -1 : 0,
          newsfeed?.background_message_posting_count
        )
      )
      setPendingMessgeCount(newsfeed?.background_message_posting_count)
    }
  }, [loadedFeeds, apiTriggeredForNewContent, newsfeed?.background_message_posting_count])

  useEffect(() => {
    // nativeapp
    if (isNative && pagination.isPagination) {
      setOrganizationId(urlSearchParams('organization_id'))
      setWorkplaceIds(urlSearchParams('id_workplace').toString())
      dispatch(
        commonFeedActions.getFeeds(
          'organization',
          urlSearchParams('organization_id'),
          pagination,
          false, //is new content
          urlSearchParams('id_workplace').toString(),
          'members'
        )
      )
      return
    }

    if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
      const workplaceIds = current_organization.info.my_access.role_as_workplace_member.workplace_list
      if (workplaceIds && workplaceIds.length >= 1 && pagination.isPagination) {
        setOrganizationId(current_organization.info.id)
        setWorkplaceIds(workplaceIds.toString())
        dispatch(
          commonFeedActions.getFeeds(
            'organization',
            current_organization.info.id,
            pagination,
            false, //is new content
            workplaceIds.toString(),
            'members'
          )
        )
      }
    }
  }, [dispatch, pagination])

  const deleteFile = (messageId, fileId) => {
    dispatch(
      generalFeedActions.deleteFileFromMessage(messageId, fileId, getCurrentQuantity(), organizationId, workplaceIds)
    )
  }

  const handleAddCoorganizer = (userId) => {
    if (group) {
      dispatch(generalFeedActions.addStaffRole(group.id, userId, 'co-organizer'))
    }
  }
  const handleRemoveCoorganizer = (userId) => {
    if (group) {
      dispatch(generalFeedActions.removeStaffRole(group.id, userId, 'staff_members'))
    }
  }
  const handleRemoveFromGroup = (userId) => {
    if (group) {
      dispatch(generalFeedActions.removeFromGroup(group.id, userId))
    }
  }
  const handleSelectedNewsFeed = (selectedFeed) => {
    dispatch(generalFeedActions.setSelectedNewsFeed(selectedFeed))
  }

  return (
    <div className={styles.feedsWrapper} id='feedsWrapper'>
      <NewFeed
        type='feed'
        entity={selectedNewsFeed}
        isGeneral={true}
        mixrFeeds={mixrs}
        groupFeeds={groups}
        handleSelectedNewsFeed={handleSelectedNewsFeed}
        draftMessage={message_draft}
      />
      {!loadingFeeds && pendingMessgeCount > 0 && <PendingMessageCount from='feed' count={pendingMessgeCount} />}

      {loadedFeeds && (list?.length >= 1 || availableCTAs.length > 0) ? (
        <React.Fragment>
          <FeedsTabContent
            type='feed'
            organizationId={organizationId}
            workplaceIds={workplaceIds}
            entity={{ type: '', id: '', name: '', picture: '' }}
            isMember={true} // all general feeds are of groups/mixrs where user is a member
            lastFeedRef={lastFeedRef}
            handleAddCoorganizer={handleAddCoorganizer}
            handleRemoveCoorganizer={handleRemoveCoorganizer}
            handleRemoveFromGroup={handleRemoveFromGroup}
            totalUsers={tagUsersList}
            availableCTAs={availableCTAs}
            loadingFeeds={loadingFeeds}
            feedIdToScroll={feedIdToScroll}
            setFeedIdToScroll={setFeedIdToScroll}
          />
          {loadingFeeds && pagination.isPagination && <Spinner />}
        </React.Fragment>
      ) : serverErrors ? (
        <ErrorMessage className={styles.error} text={serverErrors} center={true} />
      ) : loadingFeeds ? (
        <Spinner />
      ) : null}
    </div>
  )
}
